import axios from '../axiosConfig';

const pad = (value) => String(value).padStart(2, '0');

const formatDateTime = (date) => {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

const extractList = (response) => {
  if (!response || !response.data) return [];
  if (Array.isArray(response.data)) return response.data;
  if (Array.isArray(response.data.data)) return response.data.data;
  if (Array.isArray(response.data.list)) return response.data.list;
  if (response.data.data && Array.isArray(response.data.data.list)) {
    return response.data.data.list;
  }
  return [];
};

export const fetchAvailableTechnicians = async (lang = 'zh', options = {}) => {
  const { limit } = options;
  const now = new Date();
  const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);

  const [technicianResponse, appointmentsResponse] = await Promise.all([
    axios.get(`/jiaolianxinxi/autoSort?lang=${lang}`),
    axios.get('/jiaolianyuyue/list', {
      params: {
        sfsh: '是',
        'start_time_start': formatDateTime(now),
        'start_time_end': formatDateTime(oneHourLater),
        page: 1,
        limit: 1000
      }
    })
  ]);

  const technicians = extractList(technicianResponse);
  const appointments = extractList(appointmentsResponse);

  const busySet = new Set(
    appointments
      .filter((item) => item && (item.jiaolianbianhao || item.coachId))
      .map((item) => String(item.jiaolianbianhao || item.coachId))
  );

  const availableTechnicians = technicians.filter(
    (tech) => tech && !busySet.has(String(tech.jiaolianbianhao))
  );

  return typeof limit === 'number' ? availableTechnicians.slice(0, limit) : availableTechnicians;
};

export const filterStarTechnicians = (technicians = [], minLevel = 3) => {
  return technicians.filter((tech) => {
    const levelValue = Number(tech?.jiaoliandengji);
    return !Number.isNaN(levelValue) && levelValue > minLevel;
  });
};

